import { Controller } from "@hotwired/stimulus"

// Keeps placeholder links (href="#") inside the element from jumping to the top
// of the page, for demo markup like the brand page's component library. Mount on
// a container with data-action="click->inert-links#prevent". Replaces per-link
// onclick="return false", which the enforcing CSP blocks.
export default class extends Controller {
    prevent(event) {
        if (event.target.closest('a[href="#"]')) event.preventDefault()
    }
}
